export default "6557e60d50499ead.svg"